import * as React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import { Button, Form, Input, Space, Tabs, Spin, TabsProps, Table, Typography } from 'antd';
import { Box, CircularProgress, Stack } from '@mui/material';
import { UserOutlined, ContainerFilled, FileTextOutlined } from '@ant-design/icons';
import InputForm from './InputT';
import { ColumnsType } from 'antd/es/table';
import axios from 'axios';
import ParamsPicklist from '../Types/ParamsPicklist';
import DataType from '../Types/DataTablePiclist';
import Datas from "../Data/Data.json"
import { Crypter } from '../Functions/Security/Crypter';
import { useAuthHeader } from '../Services/Auth/sessionAuth';
import { type } from 'os';
import SweetAlert from 'sweetalert2';
import Swal from 'sweetalert2';


//let LinkSourceApi= require('../../Data/Data.json');

//structure de parametre d'api de recherche
/*interface Params{
  CodeAgence?:string,
  Table:string,
  Colonne1:string,
  Colonne2:string,
  Colagence?:string,
  choix:number
 }
 */


export interface ConfirmationDialogRawProps {
  id: string;
  keepMounted: boolean;
  value: string;
  onClose: (value?: string) => void;
}


const SearchInput = (props: { Titre: string, label: string, name: string, data?: any, Taille1?: number | string, Taille2?: number | string, Parametre?: ParamsPicklist, form?: any, notRequired?: true, defaultCode?: string, defaultLibelle?: string, width?: number, enable?: true, handleFunction?: any, dissabledCode?: boolean, dissabledLib?: boolean, notremove?: true, requieredLib? : boolean }) => {

  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [Libelle, SetLibelle] = React.useState(props.defaultLibelle);
  const [Code, SetCode] = React.useState(props.defaultCode);
  const [Data, SetData] = React.useState<DataType[]>(props.data);
  const [searchLoading, setSearchLoading] = React.useState(false);
  const [SearchR, SetSearchR] = React.useState<string>("");
  let notR = props.notRequired ? false : true
  // let enableLib = props.enable? false : true


  const columns: ColumnsType<DataType> = [
    {
      title: 'Code',
      dataIndex: 'Code',
    },
    {
      title: 'Libelle',
      dataIndex: 'Libelle',
      filteredValue: [SearchR],
      onFilter: (value: any, record: any) => {
        return String(record.Code)
          .toLowerCase()
          .includes(value.toLowerCase()) ||
          String(record.Libelle)
            .toLowerCase()
            .includes(value.toLowerCase())
      },
    }];



  // USER TOKEN
  const authHeader = useAuthHeader()

  const handleClickOpen = () => {
    setSelectedRowKeys([])
    setOpen(true);
  };

  const handleClose = (o: number) => {
    if (o == 0) {
      setOpen(false);
    }
    else {
    }
  };




  //CodeAgence:'',Table: "TITRES",Colonne1:"CDTITR",Colonne2:"LIBELL1",Colagence:'101',Init:values.text,choix:22

  const onFinis = async (values: any) => {

    setLoading(true);
    const datat: DataType[] = [];

    var data = { CodeAgence: props.Parametre?.CodeAgence, Table: props.Parametre?.Table, Colonne1: props.Parametre?.Colonne1, Colonne2: props.Parametre?.Colonne2, Colagence: props.Parametre?.Colagence, Init: values.text, choix: props.Parametre?.Choix, colfiltre: props.Parametre?.colfiltre, valfiltre: props.Parametre?.valfiltre }
    console.log(Crypter.encrypt(JSON.stringify(data)))
    //console.log(Crypter.encrypt(JSON.stringify(data)))
    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.AnySearch,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherSearch': Crypter.encrypt(JSON.stringify(data))
      }
    };

    await
      axios(config)
        .then((response) => {
          //alert('ok')
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
            if (res.StatutCode == 200) {
              let datas = res.Result.Table;

              if (datas.length === 0) {
                //console.log("aucun élément ");
                SetData(datat)
              }
              else {
                datas.map((data: any, indice: number) => {
                  //console.log(JSON.stringify(data))
                  datat.push({
                    key: indice,
                    Code: data[Object.keys(data)[1]],
                    Libelle: data[Object.keys(data)[0]],
                  });
                  SetData(datat);
                })
                // for(let i=0;i<=datas.length;i++)
                // {
                //   datat.push({
                //     key: i,
                //     Code: datas[i][1],
                //     Libelle: datas[i][0],
                //   });
                //   SetData(datat);  
                // }
              }
            }
          }
          setLoading(false);

        }).catch((error) => {
          console.log(error)
          setLoading(false);
          // SweetAlert.fire({title: "Error", text : error})
        })


  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab'>
          <Typography><UserOutlined />IDENTIFIANT</Typography>
        </span>
      ),
      children: <InputForm notRequired name='text' type='text' label='IDENTIFIANT' />,
    },
    {
      key: '2',
      label: (
        <span id='Tab'>
          <Typography><FileTextOutlined />LIBELLE</Typography>
        </span>
      ),

      children: <InputForm notRequired name='text' type='text' label='LIBELLE' />,
    },
    {
      key: '3',
      label: (
        <span id='Tab'>
          <Typography><ContainerFilled />ALL</Typography>
        </span>
      ),
      children: <Box fontStyle={'inherit'} display={'flex'}><InputForm taille={600} noupercase autoFocus onChange={(e: any) => { SetSearchR(e.target.value.trim()); }} notRequired name='text' type='text' label='TEXT' /><hr /> <Button onClick={onFinis} style={{ top: "10px" }}>Rechercher</Button></Box>,
    },
  ];

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  const [selectedRowKeys, setSelectedRowKeys] = React.useState<React.Key[]>([]);

  const onSelectChange = (newSelectedRowKeys: any) => {
    console.log('selectedRowKeys changed: ', Data[newSelectedRowKeys]);
    setSelectedRowKeys(newSelectedRowKeys);
    SetLibelle(Data[newSelectedRowKeys].Libelle);
    SetCode(Data[newSelectedRowKeys].Code);
    setTimeout(() => { setOpen(false) }, 250);

    props.form.setFieldValue(
      props.name, Data[newSelectedRowKeys].Code
    );
    props.form.setFieldValue(
      "lib_" + props.name, Data[newSelectedRowKeys].Libelle
    );

    if (props.handleFunction) {
      props.handleFunction();
    }

  };



  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  function handleReset() {
    //console.log(props.name)
  props.form.setFieldValue(props.name, "")
    props.form.setFieldValue("lib_" + props.name, "")
    //props.form.resetFields()
  };
  // const hasSelected = selectedRowKeys.length > 0;

  function handleSearch(e: any) {
    if ((e.key == 'Tab' || e.key == undefined) && e.target.value != '') {
      setSearchLoading(true)
      setLoading(true);
      const datat: DataType[] = [];

      var data = { CodeAgence: props.Parametre?.CodeAgence, Table: props.Parametre?.Table, Colonne1: props.Parametre?.Colonne2, Colonne2: props.Parametre?.Colonne1, Colagence: props.Parametre?.Colagence, Init: e.target.value, choix: props.Parametre?.Choix? props.Parametre?.Choix:221 , colfiltre: props.Parametre?.colfiltre, valfiltre: props.Parametre?.valfiltre }
      //console.log(Crypter.encrypt(JSON.stringify(data)))
      var config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Datas.ApiUrl.AnySearch,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authHeader(),
          'CypherSearch': Crypter.encrypt(JSON.stringify(data))
        }
      };
      axios(config)
        .then((response) => {
          //alert('ok')
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
            //(JSON.stringify(res));
         
            if (res.StatutCode == 200) {
              let datas = res.Result.Table;

              if (datas.length === 0) {
                //console.log("aucun élément ");
                SetData(datat)
                if (!props.notremove) {
                  SetCode("")
                  SetLibelle("")
                  props.form.setFieldValue("lib_" + props.name, "")
                  handleReset()
                }
                else {
                  SetLibelle("")
                  props.form.setFieldValue("lib_" + props.name, "")
                }

              }
              else if (datas.length === 1) {
                datas.map((data: any, indice: number) => {
                  //console.log(JSON.stringify(data))
                  datat.push({
                    key: indice,
                    Code: data[Object.keys(data)[0]],
                    Libelle: data[Object.keys(data)[1]],
                  });
                  SetData(datat);
                  SetCode(datat[0].Code)
                  SetLibelle(datat[0].Libelle)
                  props.form.setFieldValue(props.name, datat[0].Code)
                  props.form.setFieldValue("lib_" + props.name, datat[0].Libelle)

                  if (props.handleFunction) {
                    props.handleFunction();
                  }

                })
              }
              else {
                if (!props.notremove) {
                  SetCode("")
                  SetLibelle("")
                  props.form.setFieldValue("lib_" + props.name, "")
                  handleReset()
                }
                else {
                  SetLibelle("")
                  props.form.setFieldValue("lib_" + props.name, "")
                }
                
                Swal.fire({
                  icon: "warning",
                  title: 'Plusieurs resultats trouvés'
                })
              }
            }
            else {
              if (!props.notremove) {
                SetCode("")
                SetLibelle("")
                props.form.setFieldValue("lib_" + props.name, "")
                handleReset()
              } else {
                SetLibelle("")
                props.form.setFieldValue("lib_" + props.name, "")
              }
            }

          }
          setLoading(false);
          setSearchLoading(false)

        }).catch((error) => {
          // SetCode("")
          SetLibelle("")
          props.form.setFieldValue("lib_" + props.name, "")
          setSearchLoading(false)
          console.log(error)
          setLoading(false);
          SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
        })
    }
  }

  return (
    <div className='bordure2'>
      <Form.Item   preserve={true} label={props.label} labelCol={{ span: props.width, style: { whiteSpace: 'pre-wrap' } }}>
        <Space.Compact block>
          <Form.Item rules={[{ required: notR, message: "" }]} name={props.name}>
            <Input.Search disabled={props.dissabledCode ? props.dissabledCode : false} onBlur={handleSearch} value={Code} onChange={(e) => { SetCode(e.target.value) }} defaultValue={props.defaultCode} onKeyDown={handleSearch} type='text' style={{ width: props.Taille1 }} onSearch={handleClickOpen} />
          </Form.Item>
          {/* <Input name={props.name} title={Code} suffix={searchLoading? <CircularProgress color='inherit' size={12}/>: ""} type = 'text' value={Code} disabled style={{width: "50%"}}/> */}
          <Form.Item name={"lib_" + props.name}>
            <Input
              required={props.requieredLib}
              onInput={e => (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.toUpperCase()}
              disabled={typeof props.dissabledLib !== "undefined" ? props.dissabledLib : true} title={Libelle} suffix={searchLoading ? <CircularProgress color='inherit' size={12} /> : ""} value={Libelle} style={{ width: props.Taille2 }} />
          </Form.Item>
        </Space.Compact>
      </Form.Item>
      <Dialog
        className='modal'
        onClick={() => { handleClose(1) }}
        sx={{ '& .MuiDialog-paper': { minWidth: 'sm', maxHeight: 'md' } }} maxWidth='md' open={open} onClose={() => { handleClose(0) }} >

        <DialogTitle>{props.Titre}</DialogTitle>
        <DialogContent dividers></DialogContent>
        <Spin spinning={loading} tip="En Cour de Traitement ..." style={{ color: '#116599' }} >
          <Stack direction='row' spacing={5}>
            <Form disabled={false} name="basi" wrapperCol={{ span: 16 }} style={{ minWidth: 600, marginLeft: 50 }} initialValues={{ remember: true }} onFinish={onFinis} onFinishFailed={onFinishFailed}  >
              <Tabs defaultActiveKey="3" items={items} />
            </Form>
          </Stack>
          <DialogContent dividers>
            <Table style={{ width: 'auto' }} rowSelection={{ ...rowSelection, type: "radio", getCheckboxProps: (reccord) => ({ disabled: false }) }} columns={columns} dataSource={Data} pagination={{ defaultPageSize: 6 }} scroll={{ y: 250, x: 10 }} />
          </DialogContent>
        </Spin>
        <DialogActions>
          <Button disabled={false} type='default' color='red' onClick={() => { SetData([]); handleClose(0) }}>Fermer</Button>
        </DialogActions>
      </Dialog>

    </div>
  );
}

export default SearchInput;